import { BaseError } from '~/errors/BaseError'

export class NotFoundError extends BaseError {
  constructor(message: string) {
    super(message, 'NotFoundError', new Date().toISOString())
    this.name = this.error
  }
}
